import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, take, takeUntil, timeout } from 'rxjs/operators';
import { DataSourcesEnum } from 'src/app/enums/DataSourcesEnum';
import { IReportSeatsWon } from 'src/app/interfaces/IReportSeatsWon';
import { ISelectPage } from 'src/app/interfaces/ISelectPage';
import { ElectionService } from 'src/app/services/election.service';


@Component({
  selector: 'two-cp-table',
  templateUrl: './two-cp-table.component.html',
  styleUrls: ['./two-cp-table.component.scss']
})
export class TwoCPTableComponent implements AfterViewInit, OnDestroy {

  public seatsWons: IReportSeatsWon[] = [];
  public title = '';
  public thisYear = 0;
  public prevYear = 0;
  public hasPrev = false;

  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  constructor(private electionService: ElectionService) {
    this.electionService.dataLoaded$.pipe(takeUntil(this.componentDestroyed$)).subscribe(dataLoaded => {
      if (this.isDataLoaded(dataLoaded.electionDate)) {
        this.loadChart(this.electionService.selectedPage);
      }
    });
    this.electionService.pageChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe(page => {
      this.loadChart(page);
    });
  }

  private isDataLoaded(electionDateString: string): boolean {
    const election = this.electionService.electionMap.get(electionDateString);
    if (election) {
      return election.dataSourceTrigger([
        DataSourcesEnum.HAChange,
        DataSourcesEnum.HAStatic
      ]);
    }
    return false;
  }

  ngAfterViewInit(): void {
    if (this.isDataLoaded(this.electionService.selectedPage.electionDateString ?? '')) {
      this.loadChart(this.electionService.selectedPage);
    }
  }

  private loadChart(page: ISelectPage): void {
    const election = this.electionService.electionMap.get(page.electionDateString ?? '');
    this.seatsWons = election?.electionCount?.parties.map(party => {
      return {
        partyId: party.partyId,
        party: party.partyName,
        seatsThisElection: party.leadingDistrictSeatCount,
        seatsPreviousElection: party.winningPreviousSeatCount,
        change: party.seatChange,
        colourCode: party.colourCode,
        seatList: party.leadingDistricts
      };
    }) ?? [];
  }


  ngOnDestroy(): void {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

}
